import { useEffect, useState } from 'react'
import { useAppStore } from '@/hud-bridge/store'
import { GameCanvas } from './GameCanvas'
import { MenuScreen } from './screens/MenuScreen'
import { ModeSelectScreen } from './screens/ModeSelectScreen'
import { MapSelectScreen } from './screens/MapSelectScreen'
import { BriefingScreen } from './screens/BriefingScreen'
import { DefeatScreen, VictoryScreen } from './screens/ResultScreens'
import { RecordsScreen, SettingsScreen } from './screens/RecordsSettings'

export function App() {
  const screen = useAppStore((s) => s.screen)
  const mapId = useAppStore((s) => s.mapId)
  const mode = useAppStore((s) => s.mode)
  const setScreen = useAppStore((s) => s.setScreen)
  const [roundKey, setRoundKey] = useState(0)

  const inMatch =
    screen === 'loading' ||
    screen === 'playing' ||
    screen === 'paused' ||
    screen === 'defeat' ||
    screen === 'victory'

  useEffect(() => {
    if (screen === 'loading' && mapId) {
      setRoundKey((k) => k + 1)
      const t = window.setTimeout(() => setScreen('playing'), 120)
      return () => window.clearTimeout(t)
    }
  }, [screen, mapId, setScreen])

  return (
    <div className="app-root">
      {mapId && inMatch && (
        <GameCanvas
          key={roundKey}
          active={screen === 'playing' || screen === 'paused' || screen === 'loading'}
          mapId={mapId}
          mode={mode}
        />
      )}

      <div className="overlay">
        {screen === 'menu' && <MenuScreen />}
        {screen === 'mode' && <ModeSelectScreen />}
        {screen === 'map' && <MapSelectScreen />}
        {screen === 'briefing' && <BriefingScreen />}
        {screen === 'loading' && (
          <div className="screen" style={{ justifyContent: 'center', alignItems: 'center' }}>
            <div className="panel">
              <h1 className="h1">Loading</h1>
              <p className="muted">Подготовка раскладки мин…</p>
            </div>
          </div>
        )}
        {screen === 'defeat' && <DefeatScreen />}
        {screen === 'victory' && <VictoryScreen />}
        {screen === 'records' && <RecordsScreen />}
        {screen === 'settings' && <SettingsScreen />}
      </div>
    </div>
  )
}
